import type { FC } from 'react';
import { memo, useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { GraphModal } from '../../components/GraphModal/GraphModal';
import { useWebsite } from '../../hooks/useWebsite';
import { ReactComponent as IconShare } from '../../icons/icon-share-inline.svg';
import type { BottomActionProps } from './BottomActionButton';
import { BottomActionButton } from './BottomActionButton';
import type { ShareCommentProps } from './ShareComment';
import { ShareComment } from './ShareComment';

const messages = defineMessages({ share: { defaultMessage: 'Partager', id: 'j9/dQu' } });

type ShareBottomActionProps = {
  removeLabel?: boolean;
  iconName?: string;
} & ShareCommentProps &
  Partial<BottomActionProps>;

export const ShareBottomAction: FC<ShareBottomActionProps> = memo(function ShareBottomAction(
  props,
) {
  const lazyContent = useCallback(() => <ShareComment {...props} />, [props]);
  const { disableShareDiscussion = false } = useWebsite();
  const { formatMessage } = useIntl();

  return disableShareDiscussion ? null : (
    // Wrap in span to avoid a tippy warning
    <span>
      <GraphModal placement="top-end" theme="light-border" lazyContent={lazyContent} forcePopover>
        <BottomActionButton
          className={props.className}
          icon={<IconShare className="w-3 h-3 mb-[2px]" />}
          label={!props.removeLabel ? formatMessage(messages.share) : ''}
        />
      </GraphModal>
    </span>
  );
});
